import { getLanguages } from 'core/service/user-language/translations.service';
import { Language } from 'core/service/user-language/user-language.api';
import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { languageKeys } from 'core/query-client/keys/language.keys';

export interface UseLanguagesReturn {
    languages: Language[];
    isError: boolean;
}

export const useLanguages = (): UseLanguagesReturn => {
    const { data: languages = [], isError } = usePocQuery<Language[]>({
        queryKey: languageKeys.all,
        queryFn: ({ signal }) => getLanguages({ signal }),
        staleTime: Infinity,
    });

    return { languages, isError };
};
